module.exports = __webpack_public_path__ + "static/media/img-find-us-bg-default@3x.545f857c.jpg";